import React from "react";
import styled from "styled-components";

const VoiceControlSection = ({ leftLabel, leftControl, rightLabel, rightControl }) => {
  const hasRightColumn = Boolean(rightLabel || rightControl);

  return (
    <SectionContainer>
      <LeftColumn>
        <Label>{leftLabel}</Label>
        <ControlWrapper>{leftControl}</ControlWrapper>
      </LeftColumn>
      {hasRightColumn && (
        <RightColumn>
          <Label>{rightLabel}</Label>
          <ControlWrapper>{rightControl}</ControlWrapper>
        </RightColumn>
      )}
    </SectionContainer>
  );
};

export default VoiceControlSection;

const SectionContainer = styled.div`
  display: flex;
  gap: 6px;
  width: 100%;
  padding: 8px 0;
  border-top: 1px solid ${({ theme }) => theme.sidebar.borderColor};
`;

const LeftColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
`;

const RightColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 100px;
  align-items: center;
`;

const Label = styled.span`
  font-size: 13px;
  font-weight: 500;
  color: ${({ theme }) => theme.menu.secondaryTextColor};
  min-height: 20px;
  display: flex;
  align-items: center;
`;

const ControlWrapper = styled.div`
  display: flex;
  align-items: center;
  min-height: 32px;
`;
